import { useCallback, useEffect, useState } from 'react';
import { Row } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import useDrag from 'app/shareable/hooks/useDrag';
import zowieIcon from 'assets/icons/zowie_icon.svg';

const useStyles = createStyles((theme: typeof defaultTheme) => {
  return {
    root: (props: { visible: boolean }) => {
      return {
        position: 'fixed',
        backgroundImage: `url(${zowieIcon})`,
        bottom: 25,
        right: 25,
        width: 60,
        height: 60,
        zIndex: theme.zIndex.appBar,
        opacity: props.visible ? 1 : 0,
        filter: 'drop-shadow(0 0 2px rgba(22, 45, 61, 0.36))',
        userSelect: 'none',
        transition: 'opacity .2s',
      };
    },
    dragItem: {
      position: 'absolute',
      right: '1px',
      cursor: 'move',
      padding: 3,
      color: 'white',
      fontSize: '20px',
      fontWeight: 'bold',
    },
  };
});

const ZowieLauncher = () => {
  const [visible, setVisible] = useState(true);
  const classes = useStyles({ visible });

  const [draggable, isDrugging] = useDrag();

  useEffect(() => {
    function onZowieClose() {
      window?.Chatbotize?.hide();
      setVisible(true);
    }

    document.addEventListener('ZowieOnClose', onZowieClose);

    return () => {
      document.removeEventListener('ZowieOnClose', onZowieClose);
    };
  }, []);

  const handleClick = useCallback(() => {
    if (isDrugging) return;

    window?.Chatbotize?.show();
    window?.Chatbotize?.open();
    if (draggable.current) {
      window?.Chatbotize?.updatePosition({
        desktopRight:
          window.innerWidth -
          draggable.current.offsetLeft -
          draggable.current.offsetWidth,
        desktopBottom:
          window.innerHeight -
          draggable.current.offsetTop -
          draggable.current.offsetHeight,
      });
    }

    setVisible(false);
  }, [isDrugging]);

  return (
    <Row
      ref={draggable}
      className={classes.root}
      align="center"
      // @ts-ignore
      onClick={handleClick}
    >
      <div className={classes.dragItem}>&#8942;</div>
    </Row>
  );
};

ZowieLauncher.displayName = 'ZowieLauncher';

export default ZowieLauncher;
